<template>
    <div>

        <vue-headful title="Company Safety Profile :: EHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item font-weight-light"><i class="fa fa-cogs"></i> Admin</li>
                <li class="breadcrumb-item active">Company Safety Profile</li>
            </ol>
        </h4>

        <template v-if="loading">
            <i class="fa fa-spinner fa-spin"></i> Loading
        </template>
        <div class="row" v-else>
            <div class="col-xl-9 col-12">
                <div class="card mb-3">
                    <div class="card-header">
                        <strong>Company Information</strong>
                    </div>
                    <div class="card-body">
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.subcontractor_name }">Company Name:
                                <br>
                                <small>This must match the name on the W9 provided. Enter differing or other names below.</small>
                            </label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-input v-model="subcontractor.subcontractor_name" type="text" placeholder="Enter Company Name" :class="{'is-invalid': errors.subcontractor_name}"></b-form-input>

                                <span v-if="errors.subcontractor_name" class="text-danger">
                                    <span v-for="error in errors.subcontractor_name">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.has_other_names }">
                                Other Names:<br><small>Has the company operated under other names?</small>
                            </label>
                            <div class="col-md-8 col-sm-8">
                                <b-form-radio-group plain v-model="subcontractor.has_other_names" class="mt-2">
                                    <b-form-radio value="1">Yes</b-form-radio>
                                    <b-form-radio value="0">No</b-form-radio>
                                </b-form-radio-group>

                                <span v-if="errors.has_other_names" class="text-danger">
                                    <span v-for="error in errors.has_other_names">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row" v-if="subcontractor.has_other_names == 1">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.other_names }">
                                List Other Names:<br><small>Clarify whether other name is former name, affiliate, subsidiary, etc.</small>
                            </label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-textarea v-model="subcontractor.other_names" type="text" placeholder="List all other Company Names" :class="{'is-invalid': errors.other_names}" rows="3"></b-form-textarea>

                                <span v-if="errors.other_names" class="text-danger">
                                    <span v-for="error in errors.other_names">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.address }">Address:</label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-input v-model="subcontractor.address" type="text" placeholder="Enter Company Address" :class="{'is-invalid': errors.address}"></b-form-input>

                                <span v-if="errors.address" class="text-danger">
                                    <span v-for="error in errors.address">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.city }">City:</label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-input v-model="subcontractor.city" type="text" placeholder="Enter Company City" :class="{'is-invalid': errors.city}"></b-form-input>

                                <span v-if="errors.city" class="text-danger">
                                    <span v-for="error in errors.city">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.state_id }">State:</label>
                            <div class="col-md-8 col-sm-8">

                                <select v-model="subcontractor.state_id" class="form-control" :class="{'is-invalid': errors.state_id}">
                                    <option :value="null">-- Select a State --</option>
                                    <option v-for="state in states" :value="state.state_id">{{ state.state_code }}</option>
                                </select>

                                <span v-if="errors.state_id" class="text-danger">
                                    <span v-for="error in errors.state_id">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.zip }">Zip:</label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-input v-model="subcontractor.zip" type="text" placeholder="Enter Zip Code" :class="{'is-invalid': errors.zip}" style="max-width: 150px;"></b-form-input>

                                <span v-if="errors.zip" class="text-danger">
                                    <span v-for="error in errors.zip">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <hr/>

                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.company_contact_name }">
                               Company Contact Name:
                           </label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-input type="text" v-model="subcontractor.company_contact_name" :class="{'is-invalid': errors.company_contact_name}" placeholder="Enter Name"></b-form-input>

                                <span v-if="errors.company_contact_name" class="text-danger">
                                    <span v-for="error in errors.company_contact_name">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.company_contact_phone }">
                               Company Contact Phone:
                           </label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-input type="text" v-model="subcontractor.company_contact_phone" :class="{'is-invalid': errors.company_contact_phone}" placeholder="Enter Phone Number"></b-form-input>

                                <span v-if="errors.company_contact_phone" class="text-danger">
                                    <span v-for="error in errors.company_contact_phone">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.company_contact_email }">
                               Company Contact Email:
                           </label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-input type="email" v-model="subcontractor.company_contact_email" :class="{'is-invalid': errors.company_contact_email}" placeholder="Enter Email"></b-form-input>

                                <span v-if="errors.company_contact_email" class="text-danger">
                                    <span v-for="error in errors.company_contact_email">{{ error }}</span>
                                </span>
                            </div>
                        </div>

                        <hr/>

                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.phone }">Phone:</label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-input v-model="subcontractor.phone" type="text" placeholder="Enter Phone " :class="{'is-invalid': errors.phone}"></b-form-input>

                                <span v-if="errors.phone" class="text-danger">
                                    <span v-for="error in errors.phone">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.fax }">Fax:</label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-input v-model="subcontractor.fax" type="text" placeholder="Enter Fax" :class="{'is-invalid': errors.fax}"></b-form-input>

                                <span v-if="errors.fax" class="text-danger">
                                    <span v-for="error in errors.fax">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.office_type_id }">Office Type:</label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-select v-model="subcontractor.office_type_id" :options="officeTypeOptions" :class="{'is-invalid': errors.office_type_id}" />

                                <span v-if="errors.office_type_id" class="text-danger">
                                    <span v-for="error in errors.office_type_id">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row" v-if="subcontractor.office_type_id == 4">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.office_type_other }">Other Office Type:</label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-input type="text" v-model="subcontractor.office_type_other" :class="{'is-invalid': errors.office_type_other}" placeholder="Enter Other Office Type"></b-form-input>

                                <span v-if="errors.office_type_other" class="text-danger">
                                    <span v-for="error in errors.office_type_other">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <hr/>

                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.business_start_date }">Business Start Date:
                                <br>
                                <small>Or best approximation</small>
                            </label>
                            <div class="col-md-8 col-sm-8">

                                <date-picker v-model="business_start_date" :config="{format: 'MM/YYYY', useCurrent: false, viewMode: 'months'}" :class="{ 'is-invalid': errors.business_start_date }" placeholder="Start of Business" autocomplete="off"></date-picker>

                                <span v-if="errors.business_start_date" class="text-danger">
                                    <span v-for="error in errors.business_start_date">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.parent_company }">
                                Parent Company <br>
                                <small>List name &amp; address (If applicable)</small>
                            </label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-textarea v-model="subcontractor.parent_company" type="text" placeholder="Parent Company Name and Address" :class="{'is-invalid': errors.parent_company}" rows="3"></b-form-textarea>

                                <span v-if="errors.parent_company" class="text-danger">
                                    <span v-for="error in errors.parent_company">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.website }">Website:</label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-input type="text" v-model="subcontractor.website" :class="{'is-invalid': errors.website}" placeholder="Enter Company Website"></b-form-input>

                                <span v-if="errors.website" class="text-danger">
                                    <span v-for="error in errors.website">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-header">
                        <strong>Diverse Business Designations</strong> <button type="button" class="btn btn-sm btn-success" v-on:click="newDesignation()"><i class="fa fa-plus-circle"></i></button>
                    </div>
                    <div class="card-body">
                        <sub-designation-list :subcontractorId="subcontractor.subcontractor_id" :editMode="true" :showTitle="false" :enableOther="true" />

                        <sub-designation-modal ref="subDesignationModal" :subcontractorId="subcontractor.subcontractor_id" :enableOther="true" />
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-header">
                        <strong>Professional Licenses</strong> <button type="button" class="btn btn-sm btn-success" v-on:click="newLicense()"><i class="fa fa-plus-circle"></i></button>
                    </div>
                    <div class="card-body">
                        <sub-license-list :subcontractorId="subcontractor.subcontractor_id" :editMode="true" :showTitle="false" :enableOtherLicense="true" />

                        <sub-license-modal ref="subLicenseModal" :subcontractorId="subcontractor.subcontractor_id" :enableOtherLicense="true" />
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-header">
                        <strong>Work Performed</strong>
                    </div>
                    <div class="card-body">
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.subTrades }">
                               Trades Performed:<br>
                               <small>Check all that apply</small>
                            </label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-checkbox-group plain stacked v-model="subcontractor.subTrades" :options="tradeOptions"></b-form-checkbox-group>

                                <b-input-group class="mt-2" size="sm" style="max-width: 250px;">
                                    <b-form-input v-model="new_trade_name" placeholder="Enter a New Trade"></b-form-input>

                                    <template slot="append">
                                        <button class="btn btn-xs btn-default" title="Add a Trade" v-on:click="addTrade()" :disabled="addingTrade">
                                            <i class="fa fa-spinner fa-spin" v-if="addingTrade"></i>
                                            <i class="fa fa-plus-circle" v-else></i>
                                        </button>
                                    </template>
                                </b-input-group>

                                <span v-if="errors.subTrades" class="text-danger">
                                    <span v-for="error in errors.subTrades">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.other_trades }">Please list specific sub-category:</label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-input type="text" v-model="subcontractor.other_trades" :class="{'is-invalid': errors.other_trades}" placeholder="Enter specific sub-category of trade code selected above"></b-form-input>

                                <span v-if="errors.other_trades" class="text-danger">
                                    <span v-for="error in errors.other_trades">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <hr/>

                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.subAreas }">
                               Geographic Areas Willing to Work:<br>
                               <small>Check all that apply</small>
                            </label>
                            <div class="col-md-8 col-sm-8">
                                <div style="max-height: 200px; overflow-y: auto;">
                                    <b-form-checkbox-group plain stacked v-model="subcontractor.subAreas" :options="stateOptions"></b-form-checkbox-group>
                                </div>

                                <span v-if="errors.subAreas" class="text-danger">
                                    <span v-for="error in errors.subAreas">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.other_areas }">Other Areas:</label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-input type="text" v-model="subcontractor.other_areas" :class="{'is-invalid': errors.other_areas}" placeholder="Enter Other Areas if not listed above"></b-form-input>

                                <span v-if="errors.other_areas" class="text-danger">
                                    <span v-for="error in errors.other_areas">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <hr/>

                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.subRegistrations }">
                               State Registrations:<br>
                               <small>Check all states in which your company is registered to do business</small>
                            </label>
                            <div class="col-md-8 col-sm-8">
                                <div style="max-height: 200px; overflow-y: auto;">
                                    <b-form-checkbox-group plain stacked v-model="subcontractor.subRegistrations" :options="stateOptions"></b-form-checkbox-group>
                                </div>

                                <span v-if="errors.subRegistrations" class="text-danger">
                                    <span v-for="error in errors.subRegistrations">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.other_bus_registrations }">Other States: <br><small>If your state is not listed above, add it here:</small></label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-input type="text" v-model="subcontractor.other_bus_registrations" :class="{'is-invalid': errors.other_bus_registrations}" placeholder="Enter Other States if not listed above"></b-form-input>

                                <span v-if="errors.other_bus_registrations" class="text-danger">
                                    <span v-for="error in errors.other_bus_registrations">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-header">
                        <strong>Financial Information</strong>
                    </div>
                    <div class="card-body">
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.comp_structure_id }">
                                Company Structure:
                            </label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-select v-model="subcontractor.comp_structure_id" :options="companyStructureOptions" :class="{'is-invalid': errors.comp_structure_id}" />

                                <span v-if="errors.comp_structure_id" class="text-danger">
                                    <span v-for="error in errors.comp_structure_id">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row" v-if="subcontractor.comp_structure_id == 6">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.comp_structure_other }">Other Structure:</label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-input type="text" v-model="subcontractor.comp_structure_other" :class="{'is-invalid': errors.comp_structure_other}" placeholder="Enter Other Company Structure"></b-form-input>

                                <span v-if="errors.comp_structure_other" class="text-danger">
                                    <span v-for="error in errors.comp_structure_other">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                         <div class="form-group row">
                             <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.db_number }">Dun &amp; Bradstreet Number:</label>
                             <div class="col-md-8 col-sm-8">

                                 <b-form-input type="text" v-model="subcontractor.db_number" :class="{'is-invalid': errors.db_number}" placeholder="Enter Dun &amp; Bradstreet Number"></b-form-input>

                                 <span v-if="errors.db_number" class="text-danger">
                                     <span v-for="error in errors.db_number">{{ error }}</span>
                                 </span>
                             </div>
                         </div>
                         <div class="form-group row">
                             <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.bank_name }">Name of Your Company's Bank:</label>
                             <div class="col-md-8 col-sm-8">

                                 <b-form-input type="text" v-model="subcontractor.bank_name" :class="{'is-invalid': errors.bank_name}" placeholder="Enter Name of Company Bank"></b-form-input>

                                 <span v-if="errors.bank_name" class="text-danger">
                                     <span v-for="error in errors.bank_name">{{ error }}</span>
                                 </span>
                             </div>
                         </div>
                         <div class="form-group row">
                             <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.bank_address }">Bank Address:<br><small>Street, City, State, Zip</small></label>
                             <div class="col-md-8 col-sm-8">

                                 <b-form-input type="text" v-model="subcontractor.bank_address" :class="{'is-invalid': errors.bank_address}" placeholder="Enter Bank Address"></b-form-input>

                                 <span v-if="errors.bank_address" class="text-danger">
                                     <span v-for="error in errors.bank_address">{{ error }}</span>
                                 </span>
                             </div>
                         </div>
                         <div class="form-group row">
                             <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.bank_contact }">Bank Contact Name &amp; Phone:</label>
                             <div class="col-md-8 col-sm-8">

                                 <b-form-input type="text" v-model="subcontractor.bank_contact" :class="{'is-invalid': errors.bank_contact}" placeholder="Enter Bank Contact Information"></b-form-input>

                                 <span v-if="errors.bank_contact" class="text-danger">
                                     <span v-for="error in errors.bank_contact">{{ error }}</span>
                                 </span>
                             </div>
                         </div>
                         <div class="form-group row">
                             <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.company_id_num }">Federal ID# or SS#:</label>
                             <div class="col-md-8 col-sm-8">

                                 <b-form-input type="text" v-model="subcontractor.company_id_num" :class="{'is-invalid': errors.company_id_num}" placeholder="Enter Federal# of SS#"></b-form-input>

                                 <span v-if="errors.company_id_num" class="text-danger">
                                     <span v-for="error in errors.company_id_num">{{ error }}</span>
                                 </span>
                             </div>
                         </div>
                         <div class="form-group row">
                             <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.irs_w9 }">
                                <i class="fa fa-question-circle" title="Latest version available at www.irs.gov under Forms & Instructions"></i> IRS Form W9:
                            </label>
                             <div class="col-md-8 col-sm-8">

                                 <template v-if="subcontractor.irsw9_id">
                                    <div class="mb-2">
                                        <div>{{ subcontractor.irs_w9.file_name }}</div>
                                        <span v-if="!subcontractor.irs_w9.download_only">
                                            <a :href="`/files/view/${subcontractor.irs_w9.file_id}`" target="_blank">View</a>&nbsp;|&nbsp;
                                        </span>
                                        <a :href="`/files/download/${subcontractor.irs_w9.file_id}`" target="_blank">Download</a>&nbsp;|&nbsp;

                                        <a href="javascript:void(0)" @click="deleteIRSForm" class="text-danger">Delete</a>&nbsp;|&nbsp;

                                        <a href="javascript:void(0)" v-on:click="uploadIRSForm=true">Upload New IRS W9 Form</a>
                                    </div>
                                 </template>
                                 <file-uploader v-if="uploadIRSForm || !subcontractor.irsw9_id"
                                    assetType="SubPreQual"
                                    :assetId="subcontractor.subcontractor_id"
                                    :postUrl="`subcontractors/files/irsw9/${subcontractor.subcontractor_id}`"
                                    @fileUploaded="updateIRSForm" />

                                 <span v-if="errors.irs_w9" class="text-danger">
                                     <span v-for="error in errors.irs_w9">{{ error }}</span>
                                 </span>
                             </div>
                         </div>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-header"><strong>Health, Safety & Environmental</strong></div>
                    <div class="card-body">
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.company_size }">Current Number of Employees: <i v-if="!subcontractor.company_size" class="fa fa-asterisk small text-danger"></i></label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-input type="text" v-model="subcontractor.company_size" :class="{'is-invalid': errors.company_size}" placeholder="Enter Current Number of Employees"></b-form-input>

                                <span v-if="errors.company_size" class="text-danger">
                                    <span v-for="error in errors.company_size">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.safety_rep_name }">
                               Company Safety Representative Name: <i v-if="!subcontractor.safety_rep_name" class="fa fa-asterisk small text-danger"></i>
                           </label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-input type="text" v-model="subcontractor.safety_rep_name" :class="{'is-invalid': errors.safety_rep_name}" placeholder="Enter Name"></b-form-input>

                                <span v-if="errors.safety_rep_name" class="text-danger">
                                    <span v-for="error in errors.safety_rep_name">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.hse_credentials }">
                               List HSE credentials (if any):
                           </label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-input type="text" v-model="subcontractor.hse_credentials" :class="{'is-invalid': errors.hse_credentials}" placeholder="Enter HSE Credentials"></b-form-input>

                                <span v-if="errors.hse_credentials" class="text-danger">
                                    <span v-for="error in errors.hse_credentials">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.years_of_experience }">
                               Years of Experience: <i v-if="!subcontractor.years_of_experience" class="fa fa-asterisk small text-danger"></i>
                           </label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-input type="text" v-model="subcontractor.years_of_experience" :class="{'is-invalid': errors.years_of_experience}" placeholder="Enter Years of Experience"></b-form-input>

                                <span v-if="errors.years_of_experience" class="text-danger">
                                    <span v-for="error in errors.years_of_experience">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.safety_rep_phone }">
                               Company Safety Representative Phone: <i v-if="!subcontractor.safety_rep_phone" class="fa fa-asterisk small text-danger"></i>
                           </label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-input type="text" v-model="subcontractor.safety_rep_phone" :class="{'is-invalid': errors.safety_rep_phone}" placeholder="Enter Phone Number"></b-form-input>

                                <span v-if="errors.safety_rep_phone" class="text-danger">
                                    <span v-for="error in errors.safety_rep_phone">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.safety_rep_email }">
                               Company Safety Representative Email: <i v-if="!subcontractor.safety_rep_email" class="fa fa-asterisk small text-danger"></i>
                           </label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-input type="email" v-model="subcontractor.safety_rep_email" :class="{'is-invalid': errors.safety_rep_email}" placeholder="Enter Email"></b-form-input>

                                <span v-if="errors.safety_rep_email" class="text-danger">
                                    <span v-for="error in errors.safety_rep_email">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                             <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.has_written_program }">
                                Written Safety &amp; Health Program: <i v-if="subcontractor.has_written_program === null || subcontractor.has_written_program === undefined" class="fa fa-asterisk small text-danger"></i>
                            </label>
                             <div class="col-md-8 col-sm-8">

                                 <b-form-radio-group v-model="subcontractor.has_written_program" plain class="mt-2">
                                     <b-form-radio value="1">Yes</b-form-radio>
                                     <b-form-radio value="0">No</b-form-radio>
                                 </b-form-radio-group>

                                 <span v-if="errors.has_written_program" class="text-danger">
                                     <span v-for="error in errors.has_written_program">{{ error }}</span>
                                 </span>
                             </div>
                         </div>
                         <div v-if="subcontractor.has_written_program == 1" class="form-group row">
                             <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.program_file_id }">HSE Program File: <i v-if="!subcontractor.program_file_id" class="fa fa-asterisk small text-danger"></i></label>
                             <div class="col-md-8 col-sm-8">

                                 <template v-if="subcontractor.program_file_id">
                                    <div class="mb-2">
                                        <div>{{ subcontractor.program_file.file_name }}</div>
                                        <span v-if="!subcontractor.program_file.download_only">
                                            <a :href="`/files/view/${subcontractor.program_file.file_id}`" target="_blank">View</a>&nbsp;|&nbsp;
                                        </span>
                                        <a :href="`/files/download/${subcontractor.program_file.file_id}`" target="_blank">Download</a>&nbsp;|&nbsp;

                                        <a href="javascript:void(0)" @click="deleteProgramFile" class="text-danger">Delete</a>&nbsp;|&nbsp;

                                        <a href="javascript:void(0)" v-on:click="uploadProgramFile=true">Upload New Program Copy</a>
                                    </div>
                                 </template>
                                 <file-uploader v-if="uploadProgramFile || !subcontractor.program_file_id"
                                    assetType="SubPreQual"
                                    :assetId="subcontractor.subcontractor_id"
                                    :postUrl="`subcontractors/files/program/${subcontractor.subcontractor_id}`"
                                    @fileUploaded="updateProgramFile" />

                                 <span v-if="errors.program_file_id" class="text-danger">
                                     <span v-for="error in errors.program_file_id">{{ error }}</span>
                                 </span>
                             </div>
                         </div>
                         <div class="form-group row">
                             <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.emr_file_id }">
                                <i class="fa fa-question-circle" title="EMR letter produced by your worker's compensation carrier"></i> EMR Letter: <i v-if="!subcontractor.emr_file_id" class="fa fa-asterisk small text-danger"></i>
                            </label>
                             <div class="col-md-8 col-sm-8">

                                 <template v-if="subcontractor.emr_file_id">
                                    <div class="mb-2">
                                        <div>{{ subcontractor.emr_file.file_name }}</div>
                                        <span v-if="!subcontractor.emr_file.download_only">
                                            <a :href="`/files/view/${subcontractor.emr_file.file_id}`" target="_blank">View</a>&nbsp;|&nbsp;
                                        </span>
                                        <a :href="`/files/download/${subcontractor.emr_file.file_id}`" target="_blank">Download</a>&nbsp;|&nbsp;

                                        <a href="javascript:void(0)" @click="deleteEmrFile" class="text-danger">Delete</a>&nbsp;|&nbsp;

                                        <a href="javascript:void(0)" v-on:click="uploadEmrFile=true">Upload New EMR Letter</a>
                                    </div>
                                 </template>
                                 <file-uploader v-if="uploadEmrFile || !subcontractor.emr_file_id"
                                    assetType="SubPreQual"
                                    :assetId="subcontractor.subcontractor_id"
                                    :postUrl="`subcontractors/files/emr/${subcontractor.subcontractor_id}`"
                                    @fileUploaded="updateEmrFile" />

                                 <span v-if="errors.emr_file_id" class="text-danger">
                                     <span v-for="error in errors.emr_file_id">{{ error }}</span>
                                 </span>
                             </div>
                         </div>
                         <hr/>

                         <div class="my-4">
                            <sub-osha-years-list :subcontractorId="subcontractor.subcontractor_id" :years="oshaYears" :editMode="true" />
                         </div>
                         <hr/>

                         <div class="my-4">
                            <osha-citation-list :subcontractorId="subcontractor.subcontractor_id" :citations="subcontractor.citations" :editMode="true" />
                         </div>
                         <hr/>

                          <div class="form-group row">
                              <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.subFieldTrainings }">
                                 Field Craft Personnel Training:<br>
                                 <small>Check all that apply</small>
                             </label>
                              <div class="col-md-8 col-sm-8">

                                  <b-form-checkbox-group plain stacked v-model="subcontractor.subFieldTrainings" :options="fieldTrainings"></b-form-checkbox-group>

                                  <span v-if="errors.subFieldTrainings" class="text-danger">
                                      <span v-for="error in errors.subFieldTrainings">{{ error }}</span>
                                  </span>
                              </div>
                          </div>
                          <div class="form-group row">
                              <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.has_safety_orientation }">
                                 Safety Orientation:<br>
                                 <small>For New Employees</small>
                             </label>
                              <div class="col-md-8 col-sm-8">

                                  <b-form-radio-group v-model="subcontractor.has_safety_orientation" plain class="mt-2">
                                      <b-form-radio value="1">Yes</b-form-radio>
                                      <b-form-radio value="0">No</b-form-radio>
                                  </b-form-radio-group>

                                  <span v-if="errors.has_safety_orientation" class="text-danger">
                                      <span v-for="error in errors.has_safety_orientation">{{ error }}</span>
                                  </span>
                              </div>
                          </div>
                          <div class="form-group row">
                              <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.has_person_training }">
                                 Competent Person Training:
                             </label>
                              <div class="col-md-8 col-sm-8">

                                  <b-form-radio-group v-model="subcontractor.has_person_training" plain class="mt-2">
                                      <b-form-radio value="1">Yes</b-form-radio>
                                      <b-form-radio value="0">No</b-form-radio>
                                  </b-form-radio-group>

                                  <span v-if="errors.has_person_training" class="text-danger">
                                      <span v-for="error in errors.has_person_training">{{ error }}</span>
                                  </span>
                              </div>
                          </div>
                          <div class="form-group row">
                              <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.has_safety_meetings }">
                                 Employee Safety Meetings:
                             </label>
                              <div class="col-md-8 col-sm-8">

                                  <b-form-radio-group v-model="subcontractor.has_safety_meetings" plain class="mt-2">
                                      <b-form-radio value="1">Yes</b-form-radio>
                                      <b-form-radio value="0">No</b-form-radio>
                                  </b-form-radio-group>

                                  <span v-if="errors.has_safety_meetings" class="text-danger">
                                      <span v-for="error in errors.has_safety_meetings">{{ error }}</span>
                                  </span>
                              </div>
                          </div>
                          <div class="form-group row" v-if="subcontractor.has_safety_meetings == 1">
                              <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.meeting_frequency }">
                                 Frequency of Meetings:
                             </label>
                              <div class="col-md-8 col-sm-8">

                                  <b-form-radio-group v-model="subcontractor.meeting_frequency" plain class="mt-2">
                                      <b-form-radio value="Daily">Daily</b-form-radio>
                                      <b-form-radio value="Weekly">Weekly</b-form-radio>
                                      <b-form-radio value="Monthly">Monthly</b-form-radio>
                                  </b-form-radio-group>

                                  <span v-if="errors.meeting_frequency" class="text-danger">
                                      <span v-for="error in errors.meeting_frequency">{{ error }}</span>
                                  </span>
                              </div>
                          </div>
                          <div class="form-group row">
                              <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.meeting_frequency }">
                                 Title of Safety Meeting Host:
                             </label>
                              <div class="col-md-8 col-sm-8">

                                  <b-form-input type="text" v-model="subcontractor.meeting_host_title" placeholder="Enter the Title of the Staff Member who conducts the meetings" />

                                  <span v-if="errors.meeting_frequency" class="text-danger">
                                      <span v-for="error in errors.meeting_frequency">{{ error }}</span>
                                  </span>
                              </div>
                          </div>
                          <div class="form-group row">
                              <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.substance_abuse_policy }">
                                 Substance Abuse Policy:
                             </label>
                              <div class="col-md-8 col-sm-8">

                                  <b-form-radio-group v-model="subcontractor.substance_abuse_policy" plain class="mt-2">
                                      <b-form-radio value="1">Yes</b-form-radio>
                                      <b-form-radio value="0">No</b-form-radio>
                                  </b-form-radio-group>

                                  <span v-if="errors.substance_abuse_policy" class="text-danger">
                                      <span v-for="error in errors.substance_abuse_policy">{{ error }}</span>
                                  </span>
                              </div>
                          </div>
                          <div class="form-group row" v-if="subcontractor.substance_abuse_policy == 1">
                               <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.subTestings }">
                                    Testing Frequency:<br>
                                  <small>Check all that apply</small>
                              </label>
                               <div class="col-md-8 col-sm-8">

                                   <b-form-checkbox-group plain stacked v-model="subcontractor.subTestings" :options="substanceTestings"></b-form-checkbox-group>

                                   <span v-if="errors.subTestings" class="text-danger">
                                       <span v-for="error in errors.subTestings">{{ error }}</span>
                                   </span>
                               </div>
                          </div>
                          <div class="form-group row">
                              <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.safety_differentiators }">
                                  List any Safety Differentiators:<br>
                              </label>
                              <div class="col-md-8 col-sm-8">

                                  <b-form-textarea v-model="subcontractor.safety_differentiators" :class="{'is-invalid': errors.safety_differentiators}" rows="4" placeholder="i.e. OSHA/VPP partnerships; Pre-Task Planning; JSA planning; Behavior Observation program/system; Safety Awards; etc." />

                                  <span v-if="errors.safety_differentiators" class="text-danger">
                                      <span v-for="error in errors.safety_differentiators">{{ error }}</span>
                                  </span>
                              </div>
                          </div>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-header">
                        <strong>Insurance Information</strong>
                    </div>
                    <div class="card-body">
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.insurance_info }">
                                Insurance Company:<br>
                                <small>Please list name, address, and phone number</small>
                            </label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-textarea v-model="subcontractor.insurance_info" :class="{'is-invalid': errors.insurance_info}" rows="4" placeholder="Enter Insurance Company Name, Address, and Phone Number" />

                                <span v-if="errors.insurance_info" class="text-danger">
                                    <span v-for="error in errors.insurance_info">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.insurance_file_id }">
                                Certificate of Insurance:<br>
                                <small>Must reflect current, non-expired insurance coverage.<br>
                                Can be a "sample" issued to another certificate holder - with certificate holder information redacted.</small>
                            </label>
                            <div class="col-md-8 col-sm-8">
                                <template v-if="subcontractor.insurance_file_id">
                                   <div class="mb-2">
                                       <div>{{ subcontractor.insurance_file.file_name }}</div>
                                       <span v-if="!subcontractor.insurance_file.download_only">
                                           <a :href="`/files/view/${subcontractor.insurance_file.file_id}`" target="_blank">View</a>&nbsp;|&nbsp;
                                       </span>
                                       <a :href="`/files/download/${subcontractor.insurance_file.file_id}`" target="_blank">Download</a>&nbsp;|&nbsp;

                                       <a href="javascript:void(0)" @click="deleteInsuranceFile" class="text-danger">Delete</a>&nbsp;|&nbsp;

                                       <a href="javascript:void(0)" v-on:click="uploadInsuranceFile=true">Upload New Certificate</a>
                                   </div>
                                </template>
                                <file-uploader v-if="uploadInsuranceFile || !subcontractor.insurance_file_id"
                                   assetType="SubPreQual"
                                   :assetId="subcontractor.subcontractor_id"
                                   :postUrl="`subcontractors/files/insurance/${subcontractor.subcontractor_id}`"
                                   @fileUploaded="updateInsuranceFile" />

                                <span v-if="errors.insurance_file_id" class="text-danger">
                                    <span v-for="error in errors.insurance_file_id">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-header"><strong>Bonding Information</strong></div>
                    <div class="card-body">
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.bonding_company }">
                                Bonding Company:
                            </label>
                            <div class="col-md-8 col-sm-8">
                                <b-form-input type="text" v-model="subcontractor.bonding_company" :class="{'is-invalid': errors.bonding_company}" placeholder="Enter Bonding Company Name" />
                                <span v-if="errors.bonding_company" class="text-danger">
                                    <span v-for="error in errors.bonding_company">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.bonding_file }">
                                Copy of Bonding Letter:
                            </label>
                            <div class="col-md-8 col-sm-8">
                                <template v-if="subcontractor.bonding_file_id">
                                   <div class="mb-2">
                                       <div>{{ subcontractor.bonding_file.file_name }}</div>
                                       <span v-if="!subcontractor.bonding_file.download_only">
                                           <a :href="`/files/view/${subcontractor.bonding_file.file_id}`" target="_blank">View</a>&nbsp;|&nbsp;
                                       </span>
                                       <a :href="`/files/download/${subcontractor.bonding_file.file_id}`" target="_blank">Download</a>&nbsp;|&nbsp;

                                       <a href="javascript:void(0)" @click="deleteBondingLetter" class="text-danger">Delete</a>&nbsp;|&nbsp;

                                       <a href="javascript:void(0)" v-on:click="uploadBondingFile=true">Upload Copy of Bonding Letter</a>
                                   </div>
                                </template>
                                <file-uploader v-if="uploadBondingFile || !subcontractor.bonding_file_id"
                                    assetType="SubPreQual"
                                   :assetId="subcontractor.subcontractor_id"
                                   :postUrl="`subcontractors/files/bonding/${subcontractor.subcontractor_id}`"
                                   @fileUploaded="updateBondingLetter" />

                                <span v-if="errors.bonding_file" class="text-danger">
                                    <span v-for="error in errors.bonding_file">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.bonding_agent_firm }">
                                Bonding Agent &amp; Firm:
                            </label>
                            <div class="col-md-8 col-sm-8">
                                <b-form-input type="text" v-model="subcontractor.bonding_agent_firm" :class="{'is-invalid': errors.bonding_agent_firm}" placeholder="Enter Bonding Agent and Firm" />
                                <span v-if="errors.bonding_agent_firm" class="text-danger">
                                    <span v-for="error in errors.bonding_agent_firm">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.bonding_phone }">
                                Phone:
                            </label>
                            <div class="col-md-8 col-sm-8">
                                <b-form-input type="text" v-model="subcontractor.bonding_phone" :class="{'is-invalid': errors.bonding_phone}" placeholder="Enter Bonding Phone" />
                                <span v-if="errors.bonding_phone" class="text-danger">
                                    <span v-for="error in errors.bonding_phone">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.bonding_max_capacity }">
                                Max. Overall Bonding Capacity:
                            </label>
                            <div class="col-md-8 col-sm-8">
                                <b-form-input type="text" v-model="subcontractor.bonding_max_capacity" :class="{'is-invalid': errors.bonding_max_capacity}" placeholder="Enter Overall Maximum Bonding Capacity" />
                                <span v-if="errors.bonding_max_capacity" class="text-danger">
                                    <span v-for="error in errors.bonding_max_capacity">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.bonding_max_contract}">
                                Max. Bonding Capacity Per Contract:
                            </label>
                            <div class="col-md-8 col-sm-8">
                                <b-form-input type="text" v-model="subcontractor.bonding_max_contract" :class="{'is-invalid': errors.bonding_max_contract}" placeholder="Enter Maximum Bonding Capacity Per Contract" />
                                <span v-if="errors.bonding_max_contract" class="text-danger">
                                    <span v-for="error in errors.bonding_max_contract">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.bonding_start_date}">
                                Bonding Company Start Date:
                            </label>
                            <div class="col-md-8 col-sm-8">
                                <date-picker v-model="bonding_start_date" :config="{format: 'MM/DD/YYYY', useCurrent: false, viewMode: 'months'}" :class="{ 'is-invalid': errors.bonding_start_date }" placeholder="Date Company started with this Bonding Company"></date-picker>
                                <span v-if="errors.bonding_start_date" class="text-danger">
                                    <span v-for="error in errors.bonding_start_date">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.bonding_previous_companies}">
                                Previous Bonding Companies: <br>
                                <small>List all previous bonding companies</small>
                            </label>
                            <div class="col-md-8 col-sm-8">
                                <b-form-textarea v-model="subcontractor.bonding_previous_companies" :class="{'is-invalid': errors.bonding_previous_companies}" rows="3"></b-form-textarea>
                                <span v-if="errors.bonding_previous_companies" class="text-danger">
                                    <span v-for="error in errors.bonding_previous_companies">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-header"><strong>References</strong></div>
                    <div class="card-body">
                        <references-list :subcontractorId="subcontractor.subcontractor_id" :editMode="true" :showHelp="false"></references-list>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-header">
                        <strong>EEO &amp; ELIGIBILITY TO WORK</strong>
                    </div>
                    <div class="card-body">
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.has_eeo_policy }">
                               (1)(a) Written EEO Policy:<br>
                           </label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-radio-group v-model="subcontractor.has_eeo_policy" plain class="mt-2">
                                    <b-form-radio value="1">Yes</b-form-radio>
                                    <b-form-radio value="0">No</b-form-radio>
                                </b-form-radio-group>

                                <span v-if="errors.has_eeo_policy" class="text-danger">
                                    <span v-for="error in errors.has_eeo_policy">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.has_harassment_policy }">
                               (1)(b) Anti-Harassment Policy:<br>
                           </label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-radio-group v-model="subcontractor.has_harassment_policy" plain class="mt-2">
                                    <b-form-radio value="1">Yes</b-form-radio>
                                    <b-form-radio value="0">No</b-form-radio>
                                </b-form-radio-group>

                                <span v-if="errors.has_harassment_policy" class="text-danger">
                                    <span v-for="error in errors.has_harassment_policy">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.has_complaint_procedure }">
                               (1)(c) Employee Complaint Procedure:<br>
                           </label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-radio-group v-model="subcontractor.has_complaint_procedure" plain class="mt-2">
                                    <b-form-radio value="1">Yes</b-form-radio>
                                    <b-form-radio value="0">No</b-form-radio>
                                </b-form-radio-group>

                                <span v-if="errors.has_complaint_procedure" class="text-danger">
                                    <span v-for="error in errors.has_complaint_procedure">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.has_eeo_officer }">
                               (1)(d) Designated EEO Officer:<br>
                           </label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-radio-group v-model="subcontractor.has_eeo_officer" plain class="mt-2">
                                    <b-form-radio value="1">Yes</b-form-radio>
                                    <b-form-radio value="0">No</b-form-radio>
                                </b-form-radio-group>

                                <span v-if="errors.has_eeo_officer" class="text-danger">
                                    <span v-for="error in errors.has_eeo_officer">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row" v-if="subcontractor.has_eeo_officer == 1">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.eeo_officer_credentials }">
                               EEO Officer Credentials:<br>
                               <small>Please provide the EEO Office Name, Title, Phone and Email</small>
                           </label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-textarea v-model="subcontractor.eeo_officer_credentials" :class="{'is-invalid': errors.eeo_officer_credentials}" rows="4"></b-form-textarea>

                                <span v-if="errors.eeo_officer_credentials" class="text-danger">
                                    <span v-for="error in errors.eeo_officer_credentials">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.eeo_file_id }">
                               Copy of EEO Policies:
                           </label>
                            <div class="col-md-8 col-sm-8">

                                <template v-if="subcontractor.eeo_file_id">
                                   <div class="mb-2">
                                       <div>{{ subcontractor.eeo_file.file_name }}</div>
                                       <span v-if="!subcontractor.eeo_file.download_only">
                                           <a :href="`/files/view/${subcontractor.eeo_file.file_id}`" target="_blank">View</a>&nbsp;|&nbsp;
                                       </span>
                                       <a :href="`/files/download/${subcontractor.eeo_file.file_id}`" target="_blank">Download</a>&nbsp;|&nbsp;

                                       <a href="javascript:void(0)" @click="deleteEEOFile" class="text-danger">Delete</a>&nbsp;|&nbsp;

                                       <a href="javascript:void(0)" v-on:click="uploadeEEOFile=true">Upload Copy of EEO Policies</a>
                                   </div>
                                </template>
                                <file-uploader v-if="uploadeEEOFile || !subcontractor.eeo_file_id"
                                    assetType="SubPreQual"
                                   :assetId="subcontractor.subcontractor_id"
                                   :postUrl="`subcontractors/files/eeo/${subcontractor.subcontractor_id}`"
                                   @fileUploaded="updateEEOFile" />

                                <span v-if="errors.eeo_file_id" class="text-danger">
                                    <span v-for="error in errors.eeo_file_id">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.has_verify_employees }">
                               (2)(a) Verify Employee Eligibility:<br>
                               <small>to work in the U.S. (I-9 Compliance)?</small>
                           </label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-radio-group v-model="subcontractor.has_verify_employees" plain class="mt-2">
                                    <b-form-radio value="1">Yes</b-form-radio>
                                    <b-form-radio value="0">No</b-form-radio>
                                </b-form-radio-group>

                                <span v-if="errors.has_verify_employees" class="text-danger">
                                    <span v-for="error in errors.has_verify_employees">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.has_compliance_records }">
                               (2)(b) Maintain of Compliance Records:<br>
                               <small>to confirm compliance with I-9 Guidelines?</small>
                           </label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-radio-group v-model="subcontractor.has_compliance_records" plain class="mt-2">
                                    <b-form-radio value="1">Yes</b-form-radio>
                                    <b-form-radio value="0">No</b-form-radio>
                                </b-form-radio-group>

                                <span v-if="errors.has_compliance_records" class="text-danger">
                                    <span v-for="error in errors.has_compliance_records">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.e_verify_id }">
                               (2)(c) E-Verify ID Number:<br>
                               <small>(if enrolled - more information can be found at www.e-verify.gov)</small>
                           </label>
                            <div class="col-md-8 col-sm-8">

                                <b-form-input type="text" v-model="subcontractor.e_verify_id" :class="{'is-invalid': errors.e_verify_id}" placeholder="Enter ID Number" />

                                <span v-if="errors.e_verify_id" class="text-danger">
                                    <span v-for="error in errors.e_verify_id">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <b-button variant="success" v-on:click="saveProfile()" :disabled="saving">
                    <template v-if="saving">
                        Saving <i class="fa fa-spinner fa-spin"></i>
                    </template>
                    <template v-else>
                        <i class="fa fa-save"></i> Save Safety Profile
                    </template>
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                addingTrade: false,
                uploadPrequalifiedFile: true,
                uploadIRSForm: true,
                uploadProgramFile: true,
                uploadEmrFile: true,
                uploadInsuranceFile: true,
                uploadBondingFile: true,
                uploadeEEOFile: true,
                business_start_date: null,
                bonding_start_date: null,
                new_trade_name: null,
                errors: {},
                subcontractor: {},
                states: [],
                officeTypes: [],
                companyStructures: [],
                oshaYears: [],
                fieldTrainings: [],
                trades: {},
            }
        },

        computed: {
            officeTypeOptions(){
                //Setup
                var options = [{value: null, text: '-- Select an Office Type --'}];

                //Build it
                for(var i = 0; i < this.officeTypes.length; i++)
                {
                    //Append
                    options.push({value: this.officeTypes[i].office_type_id, text: this.officeTypes[i].office_name});
                }

                //Send it
                return options;
            },

            companyStructureOptions(){
                //Setup
                var options = [{value: null, text: '-- Select a Company Structure --'}];

                //Build it
                for(var i = 0; i < this.companyStructures.length; i++)
                {
                    //Append
                    options.push({value: this.companyStructures[i].comp_structure_id, text: this.companyStructures[i].comp_structure_name});
                }

                //Send it
                return options;
            },

            stateOptions(){
                //Setup
                var options = [];

                //Build it
                for(var i = 0; i < this.states.length; i++)
                {
                    //Append
                    options.push({value: this.states[i].state_id, text: this.states[i].state_name + '( '+this.states[i].state_code+' )'});
                }

                //Send it
                return options;
            },

            tradeOptions(){
                //Setup
                var options = [];

                //Build it
                for(var i = 0; i < this.trades.length; i++)
                {
                    //Append
                    options.push({value: this.trades[i].id, text: this.trades[i].trade_name});
                }

                //Send it
                return options;
            },
        },

        methods: {

            getSubcontractor: function() {
                //Get the data
                this.$http
                    .get('admin/company-safety-profile')
                    .then(response => {
                        //Set it
                        this.subcontractor = response.data.profile;
                        this.states = response.data.states;
                        this.officeTypes = response.data.officeTypes;
                        this.companyStructures = response.data.companyStructures;
                        this.oshaYears = response.data.oshaYears;
                        this.fieldTrainings = response.data.fieldTrainings;
                        //this.trades = response.data.trades;
                        //Setup
                        var trades = [];
                        var keys = Object.keys(response.data.trades);

                        //Build it
                        for(var i = 0; i < keys.length; i++)
                        {
                            //Append
                            trades.push({id: keys[i], trade_name: response.data.trades[keys[i]]});
                        }

                        //Send it
                        this.trades = trades;

                        //Setup some Vuex Stuff
                        this.$store.commit('setReferences', response.data.references);
                        this.$store.commit('setStates', response.data.states);
                        this.$store.commit('setDesignations', response.data.designations);
                        this.$store.commit('setLicenses', response.data.licenses);

                        //set the business date
                        if (this.subcontractor.business_start_date)
                        {
                            this.business_start_date = moment(this.subcontractor.business_start_date, 'YYYY-MM-DD').format('MM/YYYY');
                        }

                        //Set the bonding date
                        if (this.subcontractor.bonding_start_date)
                        {
                            this.bonding_start_date = moment(this.subcontractor.bonding_start_date, 'YYYY-MM-DD').format('MM/DD/YYYY');
                        }
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Helper
                        this.loading = false;
                    });
            },

            saveProfile(){
                //Save it
                this.saving = true;

                //Set the Date
                if (this.business_start_date)
                {
                    this.subcontractor.business_start_date = moment(this.business_start_date, 'MM/YYYY').format('YYYY-MM-DD');
                }

                //Set the Date
                if (this.bonding_start_date)
                {
                    this.subcontractor.bonding_start_date = moment(this.bonding_start_date, 'MM/DD/YYYY').format('YYYY-MM-DD');
                }

                //Get the data
                this.$http
                    .post('admin/company-safety-profile', this.subcontractor)
                    .then(response => {
                        //Set it
                        this.$toastr.success('Safety Profile Saved');
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Helper
                        this.saving = false;
                    });
            },

            newDesignation(){
                //Activate the modal
                //this.$refs.subDesignationCreateModal.showModal();
                this.$refs.subDesignationModal.setModel({
                    state_id: null,
                    designation_id: null,
                });

                //Show it
                this.$refs.subDesignationModal.showModal();
            },

            editDesignation(desig){
                //Set the bid
                this.$refs.subDesignationModal.setModel(desig);

                //Activate the modal
                this.$refs.subDesignationModal.showModal();
            },

            newLicense(){
                //Set the license
                this.$refs.subLicenseModal.setModel({state_id: null, license_id: null});

                //Activate the modal
                this.$refs.subLicenseModal.showModal();
            },

            addTrade(){
                //Make sure it's not null
                if(!this.new_trade_name)
                {
                    //Alert the user
                    this.$toastr.warning('Enter a Name for the New Trade');

                    //Stop here
                    return;
                }

                //Setup
                this.addingTrade = true;

                //Send it
                this.$http.post('admin/trade-edit', {trade_name: this.new_trade_name})
                    .then(response => {
                        //Setup
                        var trade = response.data;

                        //Push it onto trades
                        this.trades.push({id: trade.trade_id, trade_name: trade.trade_name});

                        //Push onto the subs
                        this.subcontractor.subTrades.push(trade.trade_id);

                        //Reset
                        this.new_trade_name = null;
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Helper
                        this.addingTrade = false;
                    });
            },

            updateIRSForm(payload){
                //Alert the user
                this.$toastr.success('IRS W9 Form Uploaded');

                //Set the value
                this.subcontractor.irs_w9 = payload.serverResponse;
                this.subcontractor.irsw9_id = payload.serverResponse.file_id;

                //Hide the uploader
                this.uploadIRSForm = false;
            },

            deleteIRSForm() {
                this.$http.post(`subcontractors/files-delete/irsw9/${this.subcontractor.subcontractor_id}`, {file: []})
                .then(response => {
                    this.$toastr.success('IRS W9 Form Removed');
                    this.uploadIRSForm = true
                    this.subcontractor.irsw9 = null;
                    this.subcontractor.irsw9_id = null;
                });
            },

            updateProgramFile(payload){
                //Alert the user
                this.$toastr.success('Safety & Health Program Uploaded');

                //Set the value
                this.subcontractor.program_file = payload.serverResponse;
                this.subcontractor.program_file_id = payload.serverResponse.file_id;

                //Hide the uploader
                this.uploadProgramFile = false;
            },

            deleteProgramFile() {
                this.$http.post(`subcontractors/files-delete/program/${this.subcontractor.subcontractor_id}`, {file: []})
                .then(response => {
                    this.$toastr.success('Safety & Health Program Removed');
                    this.uploadProgramFile=true
                    this.subcontractor.program_file = null;
                    this.subcontractor.program_file_id = null;
                });
            },

            updateEmrFile(payload){
                //Alert the user
                this.$toastr.success('EMR Letter Uploaded');

                //Set the value
                this.subcontractor.emr_file = payload.serverResponse;
                this.subcontractor.emr_file_id = payload.serverResponse.file_id;

                //Hide the uploader
                this.uploadEmrFile = false;
            },

            deleteEmrFile() {
                this.$http.post(`subcontractors/files-delete/emr/${this.subcontractor.subcontractor_id}`, {file: []})
                .then(response => {
                    this.$toastr.success('EMR Letter Removed');
                    this.uploadEmrFile=true
                    this.subcontractor.emr_file = null;
                    this.subcontractor.emr_file_id = null;
                });
            },

            updateInsuranceFile(payload){
                //Alert the user
                this.$toastr.success('Certificate of Insurance Uploaded');

                //Set the value
                this.subcontractor.insurance_file = payload.serverResponse;
                this.subcontractor.insurance_file_id = payload.serverResponse.file_id;

                //Hide the uploader
                this.uploadInsuranceFile = false;
            },

            deleteInsuranceFile() {
                this.$http.post(`subcontractors/files-delete/insurance/${this.subcontractor.subcontractor_id}`, {file: []})
                .then(response => {
                    this.$toastr.success('Certificate of Insurance Removed');
                    this.uploadInsuranceFile=true
                    this.subcontractor.insurance_file = null;
                    this.subcontractor.insurance_file_id = null;
                });
            },

            updateBondingLetter(payload){
                //Alert the user
                this.$toastr.success('Bonding Letter Uploaded');

                //Set the value
                this.subcontractor.bonding_file = payload.serverResponse;
                this.subcontractor.bonding_file_id = payload.serverResponse.file_id;

                //Hide the uploader
                this.uploadBondingFile = false;
            },

            deleteBondingLetter() {
                this.$http.post(`subcontractors/files-delete/bonding/${this.subcontractor.subcontractor_id}`, {file: []})
                .then(response => {
                    this.$toastr.success('Bonding Letter Removed');
                    this.uploadBondingFile=true
                    this.subcontractor.bonding_file = null;
                    this.subcontractor.bonding_file_id = null;
                });
            },

            updateEEOFile(payload){
                //Alert the user
                this.$toastr.success('EEO Policies Uploaded');

                //Set the value
                this.subcontractor.eeo_file = payload.serverResponse;
                this.subcontractor.eeo_file_id = payload.serverResponse.file_id;

                //Hide the uploader
                this.uploadeEEOFile = false;
            },

            deleteEEOFile() {
                this.$http.post(`subcontractors/files-delete/eeo/${this.subcontractor.subcontractor_id}`, {file: []})
                .then(response => {
                    this.$toastr.success('EEO Policies Removed');
                    this.uploadeEEOFile=true
                    this.subcontractor.eeo_file = null;
                    this.subcontractor.eeo_file_id = null;
                });
            },
        },

        mounted() {
            //Get the subcontractors
            this.getSubcontractor();
        },
    }
</script>
